<h2 mat-dialog-title i18n>Are you sure you want to create this listing without any pictures?</h2>
<mat-dialog-content i18n>
 Listings with pictures tend to sell better.
</mat-dialog-content>
<mat-dialog-actions class="button-panel">
  <button 
    mat-raised-button 
    color="accent" 
    [mat-dialog-close]="true"
    angulartics2On="click" 
    angularticsAction="ConfirmListNowClick"
    [angularticsCategory]="'' + data.itemToSellId">
    
    <mat-icon fontSet="material-symbols-outlined">store</mat-icon>
    <span i18n>CONTINUE ANYWAY</span>
  </button>
  <button mat-button mat-dialog-close i18n>CANCEL</button>
</mat-dialog-actions>